import React from "react";
import { css } from '@emotion/react';
import Flags from '../../data/raw/flags';
import { HandleDisplayLinks } from '../defaults/filters/linkHandler';

import {
  Card,
  CardLinkWrapper,
  CardMediaLogo,
  CardContent,
  CardTitle,
  CardUrl,
  CardLocation,
  CardType,
  CardProgram,
} from "../main/card"
import { color } from "../defaults/styles/theme";
import { Pnp } from '../defaults/assets/logos/partnerlogos/index';

const StartupCard = ({ className, data, id, recordId }) => {
    let startupFlag = Flags.features.startups;

    return (
      <CardLinkWrapper
        className={className}
        cardLink={`/${Flags.settings.protectedArea.url}/startups/` + recordId}
        active={startupFlag === "anonymize" ? "false" : startupFlag === true ? "true" : "false"}
      >
        <Card>
          <CardMediaLogo anonymize={startupFlag === "anonymize" ? true : ""} recordId={recordId} logo={startupFlag === "anonymize" ? <Pnp /> : false} />
          <CardContent anonymize={startupFlag === "anonymize" ? true : ""}>
            <CardTitle>{startupFlag === "anonymize" ? "Startup Company" : data.startup}</CardTitle>
            
            {data.country ? (
              <CardLocation country={startupFlag === "anonymize" ? "Germany" : data.country} city={startupFlag === "anonymize" ? "Berlin" : data.city} />
            ) : ''}

            {data.startup_program ? (
              <CardProgram program={startupFlag === "anonymize" ? ["Program XY"] : data.startup_program}/>
            ) : ''}

            {data.vertical ? (
              <CardType type={startupFlag === "anonymize" ? "Unset" : data.vertical} css={css`
                background: ${
                  startupFlag === "anonymize" ? 'black'
                  : data.vertical && data.vertical[0] === 'Mobility' ? color.orange
                  : data.vertical && data.vertical[0] === 'Production' ? color.red
                  : data.vertical && data.vertical[0] === 'Enterprise 2.0' ? color.blue
                  : 'black'
                };
                color: white;
              `}/>
            ) : ''}
            
            {data.url ? (
              <CardUrl url={startupFlag === "anonymize" ? "https://startup-autobahn.com" : HandleDisplayLinks(data.url)} orig_url={data.url} />
            ) : ''}

          </CardContent>
        </Card>
      </CardLinkWrapper>
    )
}

export default StartupCard;